import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectFinancial, financialListUpdateSelected } from "../../app/actions/financialActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalFinancial from "./L5ModalFinancial";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardFinancial = ({ data, moduleSelected }) => {

  debugLogPages(":: L4CardFinancial");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonFinancialCheckEnabled } = useSelector((state) => state.configuration);
  const [checked] = useState(false);
  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

  const handleToggle = () => {
      dispatch(financialListUpdateSelected(data.id));
    };

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewFinancial = (e) => {
    e.preventDefault();
    dispatch(selectFinancial(data));
    registerPanelViewInterest(dispatch, 'financial', data);
    navigate(`/end-user-search/preview-financial`);
  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Financial && data.ModuleFile_To_Financial.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Financial[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'financial', data);

    setPopupInformationTechIsOpen(true);
  };

  return (
    <li className="cards__item">
      <div className="card"
      >
        {comparisonFinancialCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="financial" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.description}
            </ReadMoreReadLess>
          </div>

          <button className="btn btn--block button-color-view" onClick={handleViewFinancial}>
            {t("buttons.view")}
          </button>

        </div>
      </div>

      <L5ModalFinancial
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardFinancial;
